
export default {
  middleware: "guest",
  name: "DefaultLayout",
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.loading = false;
    });
  },
  watch: {
    $route: {
      handler() {
        const isLTR = this.$route.path.includes("en");
        this.$vuetify.rtl = !isLTR;
        this.isRight = !isLTR;
      },
      immediate: true,
    },
  },
};
